export const selectFields = [
  { label: "Family status", key: "family_status", multiple: true },
  { label: "Body type", key: "body_type", multiple: true },
  { label: "Complexion", key: "complexion", multiple: true },
  { label: "Diet", key: "diet", multiple: true, multiple: true },
  { label: "Qualification", key: "qualification", multiple: true },
  { label: "Course", key: "education", multiple: true },
  { label: "Profession", key: "profession", multiple: true },
  { label: "Mother tongue", key: "motherTongue", multiple: true },
];

export const selectData = {
  family_status: [],
  body_type: [],
  complexion: [],
  diet: [],
  qualification: [],
  education: [],
  profession: [],
  motherTongue: [],
};

export const tagOptions = [
  {
    label: "Same district",
    value: 1,
  },
  {
    label: "Same state",
    value: 2,
  },
];

export const radioFields = [
  {
    label: "Profiles sort by",
    key: "sort_by_filter",
    options: [
      { value: 1, label: "Latest profile" },
      { value: 0, label: "Not matter" },
    ],
  },
];

export const formRadioFields = [
  {
    label: "Any health/disability issues?",
    key: "disability_filter",
    options: [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },
    ],
  },
  {
    label: "Drinking",
    key: "drink_filter",
    options: [
      { value: 1, label: "Yes" },
      { value: 2, label: "No" },
      { value: 3, label: "Occasionally" },
    ],
  },
  {
    label: "Smoking",
    key: "smoke_filter",
    options: [
      { value: 1, label: "Yes" },
      { value: 2, label: "No" },
      { value: 3, label: "Occasionally" },
    ],
  },
];

export const formSelectFields = [
  { label: "Age", key: "age", multiple: false },
  { label: "Community", key: "community", multiple: true },
  { label: "Nationality", key: "nationality", multiple: true },
  { label: "Marital status", key: "marital_status", multiple: true },
];
